import { uiRoutes } from '@consumer-frontend/nc-api';

import { NcExternalLink } from '../NcExternalLink';

export const NcBasicInfoPageLegal = () => {
  return (
    <section className="legal-footer">
      <div className="legal-links">
        <span className="legal-link">
          <NcExternalLink href={uiRoutes.legacyAH.privacyPolicy}>
            Privacy Policy
          </NcExternalLink>
        </span>

        <span className="legal-link">
          <NcExternalLink href={uiRoutes.legacyAH.californiaPrivacyPolicy}>
            States Privacy Policy
          </NcExternalLink>
        </span>

        <span className="legal-link">
          <NcExternalLink href={uiRoutes.legacyAH.termsOfUse}>
            Terms of Use
          </NcExternalLink>
        </span>
      </div>

      <p className="legal-copy">This site is protected by reCAPTCHA.</p>
    </section>
  );
};
